import * as React from 'react'
import { Animated, TouchableOpacity, View } from 'react-native'
import styled from '@theme/styled-components'
import Provider from '@theme/Provider'

import { createRoot, Root } from 'react-dom/client'

interface Props {
  render: () => React.ReactElement
  width: number
}

const Component = ({ render, width }: Props) => {
  const anim = React.useMemo(() => new Animated.Value(width), [width])

  React.useEffect(() => {
    Animated.timing(anim, { toValue: 0, useNativeDriver: false, duration: 250 }).start()
  }, [width])

  const close = () => {
    Animated.timing(anim, { toValue: width, useNativeDriver: false, duration: 250 }).start(Drawer.close)
  }

  return (
    <MainContainer pointerEvents="box-none">
      <Back activeOpacity={1} onPress={close} />
      <Container width={width} style={{ transform: [{ translateX: anim }] }}>
        {render()}
      </Container>
    </MainContainer>
  )
}

const MainContainer = styled(View)`
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
`

const Back = styled(TouchableOpacity)`
  background-color: ${(props) => props.theme.colors.modalBackground};
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`

const Container = styled(Animated.View)<{ width: number }>`
  background-color: ${(props) => props.theme.colors.background};
  position: absolute;
  top: 0;
  right: 0;
  height: 100vh;
  width: ${(props) => props.width}px;
`

let portalRoot: Root | null

const Drawer = {
  open: (props: Props) => {
    const element = document.getElementById('portal_root')

    if (element) {
      const rootRenderer = createRoot(element)

      portalRoot?.unmount()

      portalRoot = rootRenderer

      rootRenderer.render(
        <Provider>
          <Component {...props} />
        </Provider>
      )
    }
  },
  close: () => {
    if (portalRoot) {
      portalRoot.unmount()
      portalRoot = null
    }
  },
}

export default Drawer
